import { Record, List } from "immutable";

import { LOADING_STATE } from "@typings/reduxThunkActions";
import { PAYMENT_METHODS } from "@typings/globals";

const LOCAL_STORAGE_KEY = "store:gift-cards";

enum GIFT_CARDS_FORM_FIELDS {
  EMAIL = "email",
  EMAIL_CONFIRMATION = "emailConfirmation",
  PHONE_NUMBER = "phoneNumber",
  AMOUNT = "amount",
  QUANTITY = "quantity",
}

interface FormFields {
  [GIFT_CARDS_FORM_FIELDS.EMAIL]: string;
  [GIFT_CARDS_FORM_FIELDS.EMAIL_CONFIRMATION]: string;
  [GIFT_CARDS_FORM_FIELDS.PHONE_NUMBER]: string;
  [GIFT_CARDS_FORM_FIELDS.AMOUNT]: number;
  [GIFT_CARDS_FORM_FIELDS.QUANTITY]: number;
}

interface PaymentMethods {
  status: LOADING_STATE;
  data: List<PAYMENT_METHODS>;
}

interface GiftCardsReducer {
  paymentMethods: Record<PaymentMethods>;
  selectedPaymentMethod: PAYMENT_METHODS | null;
}

interface GiftCardsStorage {
  values: FormFields;
  selectedPaymentMethod: PAYMENT_METHODS;
}

export {
  LOCAL_STORAGE_KEY,
  GiftCardsReducer,
  PaymentMethods as GiftCardsPaymentMethods,
  FormFields as GiftCardsFormFields,
  GIFT_CARDS_FORM_FIELDS,
  GiftCardsStorage,
};
